module.exports = __webpack_public_path__ + "img/logo.mini.2d1c2ff7.png";